import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "m-auto grid grid-cols-[repeat(auto-fill,_minmax(13rem,_1fr))] gap-2 sm:gap-4 py-1 sm:py-2"
}
const _hoisted_2 = {
  key: 1,
  class: "m-auto grid grid-cols-[repeat(auto-fill,_minmax(13rem,_1fr))] gap-2 sm:gap-4 py-1 sm:py-2"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "min-w-[13rem] w-full min-h-[calc(13rem+1.75rem)] aspect-square bg-gray-300" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 2,
  class: "flex items-center justify-center h-full"
}
const _hoisted_6 = { class: "bg-white rounded-md py-1 sm:py-2 px-2 sm:px-4 mt-1 sm:mt-2" }

import { Empty, Pagination } from 'ant-design-vue';
import { onMounted, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import SearchTopbar from '@/components/disposable/SearchTopbar.vue';
import { Metadata } from '@/model/api';
import { Comic, ComicPaginationRequest, ComicType } from '@/model/comic';
import { getComicsPagination } from '@/repository/comic';
import ComicCard from './ComicCard.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ComicListView',
  props: {
    type: {}
  },
  setup(__props: any) {

const props = __props;



const route = useRoute();
const router = useRouter();
const store = useStore();

const isFetching = ref(false);
const search = ref((route.query?.search as string) || '');
const comics = ref<Comic[]>([]);

const metadata = ref<Metadata>(initialMetadata());
function initialMetadata(): Metadata {
	return {
		limit: Number(route.query.limit) || 10,
		offset: 0,
		totalItem: 0,
		totalPage: 0,
		currentPage: Number(route.query.page) || 1
	};
}

async function fetchData() {
	const sort = 'title asc';
	const req: ComicPaginationRequest = {
		page: metadata.value.currentPage,
		offset: metadata.value.offset,
		limit: metadata.value.limit,
		type: props.type,
		search: search.value,
		sort
	};
	router.replace({
		query: {
			page: metadata.value.currentPage,
			limit: metadata.value.limit,
			search: search.value || undefined
		}
	});
	try {
		isFetching.value = true;
		const data = await getComicsPagination(req);
		if (data) {
			isFetching.value = false;
			comics.value = data.data || [];
			metadata.value = data.metadata;
			if (metadata.value.totalPage > 0 && (!data.data || !data.data.length)) {
				metadata.value.currentPage = metadata.value.totalPage;
			}
		}
	} catch (error) {
		isFetching.value = false;
		store.dispatch('alert', { type: 'error', message: 'Something went wrong, please try again!' });
	}
}

onMounted(fetchData);

watch(
	() => metadata?.value.currentPage,
	async () => (metadata?.value.currentPage !== 0 ? await fetchData() : {})
);
watch(() => metadata?.value.limit, fetchData);
watch(search, fetchData);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(SearchTopbar, {
      searchText: search.value,
      "on-add": () => _unref(router).push(`/${_ctx.type}/create`),
      "on-search": (text) => (search.value = text),
      placeholder: `Search ${_ctx.type} title`
    }, null, 8, ["searchText", "on-add", "on-search", "placeholder"]),
    _createElementVNode("div", {
      class: _normalizeClass(
			isFetching.value || comics.value?.length
				? 'min-h-[calc(100vh-80px-124px)] sm:min-h-[calc(100vh-80px-160px)]'
				: 'h-[calc(100vh-80px-124px)] sm:h-[calc(100vh-80px-160px)]'
		)
    }, [
      (!isFetching.value && comics.value?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(comics.value, (comic, index) => {
              return (_openBlock(), _createBlock(_component_router_link, {
                key: index,
                to: `/${_ctx.type}/${comic.comicUUID}`
              }, {
                default: _withCtx(() => [
                  _createVNode(ComicCard, { comic: comic }, null, 8, ["comic"])
                ]),
                _: 2
              }, 1032, ["to"]))
            }), 128))
          ]))
        : (isFetching.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array(metadata.value.limit), (_, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "rounded-md shadow-md bg-white overflow-hidden animate-pulse"
                }, _hoisted_4))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_unref(Empty))
            ]))
    ], 2),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_unref(Pagination), {
        current: metadata.value.currentPage,
        "onUpdate:current": _cache[0] || (_cache[0] = ($event: any) => ((metadata.value.currentPage) = $event)),
        "page-size": metadata.value.limit,
        "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((metadata.value.limit) = $event)),
        total: metadata.value.totalItem,
        "show-total": (total, range) => `${range[0]}-${range[1]} of ${total} items`,
        "show-size-changer": "",
        "show-quick-jumper": "",
        onChange: _cache[2] || (_cache[2] = 
				(page, pageSize) => {
					metadata.value.currentPage = page;
					metadata.value.limit = pageSize;
				}
			)
      }, null, 8, ["current", "page-size", "total", "show-total"])
    ])
  ], 64))
}
}

})